<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Afbeeldingen</h2>
                <div class="box-tools">
                    <router-link
                        class="btn btn-primary btn-xs"
                        :to="{name:'images.add.index'}"
                        v-tooltip.bottom="'Afbeelding toevoegen'"
                    >
                        <i class="mdi mdi-plus"></i>
                        <span class="sr-only">Afbeelding toevoegen</span>
                    </router-link>
                </div>
            </div>
            <div class="box-body">
                <p v-if="images.length === 0">Er zijn geen afbeeldingen gevonden</p>
                <div class="clearfix" v-if="images.length > 0">
                    <div v-for="(image, ndx) in images" class="pull-left image-box">
                        <img :src="image.url" alt="" @click="index = ndx" style="max-width:120px;max-height:120px;" />
                        <a href="javascript:void(0);" class="bg-primary openimage" @click="openImage(image)">
                            <i class="fa fa-info"></i>
                        </a>
                        <a href="javascript:void(0);" class="bg-success imageinfo"
                            @click="imageInfo(image)"
                            v-if="isGroupa"
                        >
                            <i class="mdi mdi-adobe"></i>
                        </a>
                    </div>
                </div>
                <div class="row" v-if="images.length > 0">
                    <div class="col-sm-2 col-sm-offset-5 text-center" v-show="links.next">
                        <button class="btn btn-primary btn-sm" id="loadmoreimagesbtn" :disabled="fetching" @click="loadMore()">Meer laden</button>
                    </div>
                </div>
            </div>
            <div class="overlay" v-show="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="modal fade" id="openImageModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document" v-if="selectedImage">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" @click="closeImage()" class="close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Afbeelding details</h4>
                    </div>
                    <div class="modal-body no-padding">
                        <table class="table table-striped table-hover">
                            <tbody>
                                <tr>
                                    <th>Afbeelding</th>
                                    <td>{{ selectedImage.name }}</td>
                                </tr>
                                <tr>
                                    <th>Toegevoegd door</th>
                                    <td>{{ selectedImage.creator }}</td>
                                </tr>
                                <tr>
                                    <th>Toegevoegd op</th>
                                    <td>{{ selectedImage.created_at }}</td>
                                </tr>
                                <tr>
                                    <th>Afbeelding genomen op</th>
                                    <td>{{ selectedImage.taken_at }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="imageInformationModal" tabindex="-1" role="dialog"
            v-if="isGroupa"
        >
            <div class="modal-dialog" role="document" v-if="selectedImage">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" @click="closeInfo()" class="close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Afbeelding locatie</h4>
                    </div>
                    <div class="modal-body">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" v-model="path" disabled />
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-info btn-flat"
                                    v-clipboard:copy="path"
                                    v-clipboard:success="onCopy"
                                >Kopieer</button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vue-gallery-slideshow
            :images="images"
            :index="index"
            @reaching-the-end="loadMore"
        ></vue-gallery-slideshow>
    </div>

</template>

<script>

    import axios from 'axios';
    import VueClipboard from 'vue-clipboard2';
    import Vue from 'vue';
    import VueGallerySlideshow from '../Libraries/VueGallerySlideshow';
    import { mapGetters } from 'vuex';

    VueClipboard.config.autoSetContainer = true;
    Vue.use(VueClipboard);

    export default {

        components: {
            VueGallerySlideshow,
        },

        computed: {
            ...mapGetters([
                'getAuth',
            ]),

            isGroupa() {
                if (!this.getAuth || !this.getAuth.settings || !this.getAuth.settings.archibase) {
                    return false;
                }

                return this.getAuth.settings.archibase.prefix === 'groupa';
            },
        },

        data() {
            return {
                fetching:false,
                images:[],
                index:null,
                links:[],
                loading:true,
                meta:[],
                path:'',
                selectedImage:null,
            }
        },

        methods: {

            closeImage(){
                this.selectedImage = null;
                $('#openImageModal').modal('hide');
            },

            closeInfo(){
                this.selectedImage = null;
                this.path = '';
                $('#imageInformationModal').modal('hide');
            },

            getImages(url = null){
                if (this.fetching === true) {
                    return;
                }
                this.fetching = true;
                if (url === null) {
                    url = this.imagesUri;
                }
                axios.get(url)
                .then(resp => {
                    this.images = this.images.concat(resp.data.data);
                    this.links = resp.data.links;
                    this.meta = resp.data.meta;
                    this.loading = false;
                    this.fetching = false;
                })
            },

            imageInfo(image) {
                this.selectedImage = image;
                this.path = image.networkpath;
                $('#imageInformationModal').modal('show');
            },

            loadMore() {
                if (this.links.next) {
                    this.getImages(this.links.next);
                }
            },

            onCopy() {
                this.$snotify.success("Het pad naar de afbeelding is gekopieerd");
            },

            openImage(image) {
                this.selectedImage = image;
                $('#openImageModal').modal('show');
            },

        },

        mounted() {
            this.getImages();
            this.$nextTick(function () {
                let $this = this;
                jQuery(window).scroll(function(){
                    let target = jQuery("#loadmoreimagesbtn");
                    if (typeof target.offset() === 'undefined') {
                        return;
                    }
                    let hT = target.offset().top,
                        hH = target.outerHeight(),
                        wH = $(window).height(),
                        wS = $(this).scrollTop();
                    if (wS > (hT+hH-wH) && (hT > wS) && (wS+wH > hT+hH)){
                        // Load more images
                        $this.loadMore();
                    }
                });

            }.bind(this));
        },

        name:"Images",

        props:{
            imagesUri: { required:true },
        }

    }

</script>

<style>

    div.image-box {
        width:150px;
        height:150px;
        line-height:130px;
        border:1px solid black;
        margin:10px;
        padding:10px;
        text-align:center;
        position:relative;
    }

    div.image-box a.openimage,
    div.image-box a.imageinfo {
        position:absolute;
        bottom:0;
        line-height:16px;
    }

    div.image-box a.openimage {
        left:0;
    }

    div.image-box a.imageinfo {
        right:0;
    }

    div.image-box a.openimage,
    div.image-box a.imageinfo {
        width:16px;
        height:16px;
    }

</style>
